import { Component } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@qga/roo-ui/components';

class Info extends Component {
  constructor(props) {
    super(props);
    this.state = { displayText: this.props.message };
    this.timeoutRef = null;
  }

  componentDidMount() {
    this.timeoutRef = setTimeout(() => {
      this.setState({ displayText: this.props.messageAfter10Sec });
    }, 10000);
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutRef);
  }

  render() {
    return (
      <Text fontSize={['lg', 'xl']} textAlign="center" {...this.props}>
        {this.state.displayText}
      </Text>
    );
  }
}

Info.propTypes = {
  ...Text.propTypes,
  message: PropTypes.string.isRequired,
  messageAfter10Sec: PropTypes.string,
};

export default Info;
